import { useAppSelector } from '.';
import { useCallback } from 'react';

import { notifications } from '@mantine/notifications';

import { selectAccessToken } from '@/store/user-process/user-selectors';

import { AppRoutes } from '@/router/routes';

import { useLogoutMutation } from '@/api/authorization';

import {
	createKeycloakClient,
	getAuthProvider,
	isKeycloakConfigured,
} from '@/shared/helpers/keycloak';

import { resetAuth } from '@/utils/resetAuth';

const useLogout = () => {
	const accessToken = useAppSelector(selectAccessToken);
	const [doLogout] = useLogoutMutation();

	return useCallback(async () => {
		// SSO-сессию завершает Keycloak: локальное состояние чистится после
		// возврата на /login c флагом sso_logged_out
		if (getAuthProvider() === 'sso' && isKeycloakConfigured()) {
			try {
				const keycloak = createKeycloakClient();
				await keycloak.init({ pkceMethod: 'S256', checkLoginIframe: false });
				await keycloak.logout({
					redirectUri: `${window.location.origin}${AppRoutes.Login}?sso_logged_out=1`,
				});
			} catch (err) {
				console.error(err);
				resetAuth();
			}
			return;
		}

		if (!accessToken) {
			resetAuth();
			return;
		}
		try {
			await doLogout(accessToken).unwrap();
			resetAuth();
		} catch (err) {
			notifications.show({
				message: 'Не удалось выполнить выход.',
				bg: '#ff0000',
				mah: '100%',
				maw: 'fit-content',
				mx: 'auto',
				radius: 12,
				autoClose: 5000,
				withCloseButton: false,
			});
		}
	}, [accessToken, doLogout]);
};

export default useLogout;
